export default __webpack_public_path__ + "static/logo03-74fcce4040bdb3867c831b6300466a6d.svg";